/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Quickcheck portal configuration.
 * @export
 * @interface GetServiceprovider200ResponseQuickcheck
 */
export interface GetServiceprovider200ResponseQuickcheck {
    /**
     * Allowed origin URL for the quickcheck portal.
     */
    origin: string;
    /**
     * Privacy policy URL shown in the quickcheck portal.
     */
    privacy: string;
    /**
     * Cloudflare Turnstile site key rendered in this serviceprovider's quickcheck embed form.
     */
    turnstileSiteKey?: string;
    /**
     * Whether a Cloudflare Turnstile secret key is configured for this serviceprovider. The secret itself is never returned by this endpoint.
     */
    hasTurnstileSecretKey: boolean;
}

/**
 * Check if a given object implements the GetServiceprovider200ResponseQuickcheck interface.
 */
export function instanceOfGetServiceprovider200ResponseQuickcheck(value: object): value is GetServiceprovider200ResponseQuickcheck {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('privacy' in value) || value['privacy'] === undefined) return false;
    if (!('hasTurnstileSecretKey' in value) || value['hasTurnstileSecretKey'] === undefined) return false;
    return true;
}

export function GetServiceprovider200ResponseQuickcheckFromJSON(json: any): GetServiceprovider200ResponseQuickcheck {
    return GetServiceprovider200ResponseQuickcheckFromJSONTyped(json, false);
}

export function GetServiceprovider200ResponseQuickcheckFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetServiceprovider200ResponseQuickcheck {
    if (json == null) {
        return json;
    }
    return {
        
        'origin': json['origin'],
        'privacy': json['privacy'],
        'turnstileSiteKey': json['turnstileSiteKey'] == null ? undefined : json['turnstileSiteKey'],
        'hasTurnstileSecretKey': json['hasTurnstileSecretKey'],
    };
}

export function GetServiceprovider200ResponseQuickcheckToJSON(json: any): GetServiceprovider200ResponseQuickcheck {
    return GetServiceprovider200ResponseQuickcheckToJSONTyped(json, false);
}

export function GetServiceprovider200ResponseQuickcheckToJSONTyped(value?: GetServiceprovider200ResponseQuickcheck | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'origin': value['origin'],
        'privacy': value['privacy'],
        'turnstileSiteKey': value['turnstileSiteKey'],
        'hasTurnstileSecretKey': value['hasTurnstileSecretKey'],
    };
}

